import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Blank_instancesuqgqz38q78o as Blank_instance } from './RecyclerViewRenderer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RecyclerViewRendererSet$Companion$single$1$r$1Class;
function RecyclerViewRendererSet$Companion$single$1$r$1() {
  if (RecyclerViewRendererSet$Companion$single$1$r$1Class === VOID) {
    class $ {
      constructor($render) {
        this.$render_1 = $render;
      }
      render_qs4yp2_k$(viewWriter, data, index) {
        return this.$render_1(viewWriter, data);
      }
    }
    initMetadataForClass($);
    RecyclerViewRendererSet$Companion$single$1$r$1Class = $;
  }
  return RecyclerViewRendererSet$Companion$single$1$r$1Class;
}
var RecyclerViewRendererSet$Companion$single$1Class;
function RecyclerViewRendererSet$Companion$single$1() {
  if (RecyclerViewRendererSet$Companion$single$1Class === VOID) {
    class $ {
      constructor($id, $render) {
        this.$id_1 = $id;
        var tmp = this;
        tmp.r_1 = new (RecyclerViewRendererSet$Companion$single$1$r$1())($render);
      }
      id_r7ceoc_k$(item) {
        return this.$id_1(item);
      }
      renderer_udxqk_k$(item) {
        return this.r_1;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [RecyclerViewRendererSet()]);
    RecyclerViewRendererSet$Companion$single$1Class = $;
  }
  return RecyclerViewRendererSet$Companion$single$1Class;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      id_f37lmc_k$(item) {
        return Unit_instance;
      }
      id_r7ceoc_k$(item) {
        this.id_f37lmc_k$(item);
        return Unit_instance;
      }
      renderer_3rpyro_k$(item) {
        return Blank_instance;
      }
      renderer_udxqk_k$(item) {
        return this.renderer_3rpyro_k$(item);
      }
    }
    initMetadataForObject($, 'Empty', VOID, VOID, [RecyclerViewRendererSet()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      single_mozeja_k$(id, render) {
        return new (RecyclerViewRendererSet$Companion$single$1())(id, render);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var RecyclerViewRendererSetClass;
function RecyclerViewRendererSet() {
  if (RecyclerViewRendererSetClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewRendererSet');
    RecyclerViewRendererSetClass = $;
  }
  return RecyclerViewRendererSetClass;
}
//region block: init
Empty_instance = new (Empty())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RecyclerViewRendererSet as RecyclerViewRendererSet341fhovxcnndi,
  Companion_instance as Companion_instance1yu5u0cqn8abq,
  Empty_instance as Empty_instance2wsoq14uj8bky,
};
//endregion

//# sourceMappingURL=RecyclerViewRendererSet.mjs.map
